import Joi from 'joi';

import { updateCompanyAccountContactSchema } from '../../../contacts/validators/schemas/update-company-account-contact.schema';
import { updateIndividualAccountContactSchema } from '../../../contacts/validators/schemas/update-individual-account-contact.schema';
import { updateProtoDriverSchema } from '../../../drivers/validators/schemas/update-proto-driver.schema';
import { AccountTypeEnum } from '../../enums/account-type.enum';

/**
 * Schema for existing account record validation.
 */
export const updateAccountSchema = () =>
  Joi.object({
    id: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|account-id|cannot-be-null',
      }),
      otherwise: Joi.number().required().messages({
        'any.required': 'validations|account-id|required',
        'number.base': 'validations|account-id|must-be-number',
      }),
    }),

    // Type
    type: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|account-type|cannot-be-null',
        }),
        otherwise: Joi.string()
          .valid(...Object.values(AccountTypeEnum))
          .required()
          .messages({
            'any.required': 'validations|account-type|required',
            'any.only': 'validations|account-type|invalid-value',
          }),
      })
      .prefs({ abortEarly: true }),

    // Contact. Identity and the sign-in email stay on the stored row.
    contact: Joi.object().when('type', {
      is: Joi.valid(AccountTypeEnum.INDIVIDUAL),
      then: updateIndividualAccountContactSchema(18).fork(
        ['email', 'id', 'type', 'source'],
        (schema) => schema.strip(),
      ),
      otherwise: Joi.object().when('type', {
        is: Joi.valid(AccountTypeEnum.COMPANY),
        then: updateCompanyAccountContactSchema().fork(
          ['email', 'id', 'type', 'source'],
          (schema) => schema.strip(),
        ),
      }),
    }),

    // Driver. Id and account ownership stay on the stored row.
    driver: updateProtoDriverSchema()
      .fork(['id', 'accountId'], (schema) => schema.strip())
      .allow(null),

    color: Joi.string().allow(null).messages({
      'string.base': 'validations|account-color|must-be-string',
    }),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|account-notes|must-be-string',
    }),

    files: Joi.any().allow(null),
  })
    .unknown(true)
    .options({ stripUnknown: true });
